import React from "react";
import { MDBContainer } from 'mdb-react-ui-kit';
import heavenSent from "../../assets/images/covert_art/heaven_sent.jpg";
import frozen from "../../assets/images/covert_art/frozen.jpg";
import monaLisa from "../../assets/images/covert_art/mona_lisa2.png";
import tttoxic from "../../assets/images/covert_art/tttoxic.jpg";
import "../../assets/styles/Music.css";

export default function Music () {
        return (
          <MDBContainer id="music" className="music-container" fluid>
            <div className="music-header">
              MUSIC
            </div>
            <div className="row">
            <div className="music-cover-art col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <a target="_blank" href="https://audiomack.com/tirothetyrant/song/mona-lisa">
                  <img src={monaLisa} />
                </a>
              </div>
              <div className="music-cover-art col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <a target="_blank" href="https://audiomack.com/tirothetyrant/song/heaven-sent">
                  <img src={heavenSent} />
                </a>
              </div>
              <div className="music-cover-art col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <a target="_blank" href="https://audiomack.com/tirothetyrant/song/frozen">
                  <img src={frozen} />
                </a>
              </div>
              <div className="music-cover-art col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <a target="_blank" href="https://audiomack.com/tirothetyrant/album/tttoxic-1">
                  <img src={tttoxic} />
                </a>
              </div>
            </div>
            </MDBContainer>);

}